import React, { useEffect } from 'react'
import { Snackbar, Slide } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { makeStyles } from '@material-ui/styles'
import { useNotifications } from '../../contexts/NotificationContext'
import { notificationManager } from '../../contexts/NotificationContext'

const useStyles = makeStyles((theme) => ({
  snackbar: {
    marginBottom: theme.spacing(1)
  }
}))

function SlideTransition(props) {
  return <Slide {...props} direction="up" />
}

const GlobalSnackbar = () => {
  const classes = useStyles()
  const { notifications, removeNotification, addNotification } = useNotifications()

  // Subscribe to global notification manager for JS function triggers
  useEffect(() => {
    const unsubscribe = notificationManager.subscribe((notification) => {
      addNotification(notification)
    })

    return unsubscribe
  }, [addNotification])

  if (notifications.length === 0) {
    return null
  }

  const currentNotification = notifications[0]

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    removeNotification(currentNotification.id)
  }

  const getSeverity = (type) => {
    switch (type) {
      case 'success':
        return 'success'
      case 'error':
        return 'error'
      case 'warning':
        return 'warning'
      case 'info':
      default:
        return 'info'
    }
  }

  return (
    <Snackbar
      key={currentNotification.id}
      open={true}
      autoHideDuration={currentNotification.autoHideDuration > 0 ? currentNotification.autoHideDuration : null}
      onClose={handleClose}
      TransitionComponent={SlideTransition}
      anchorOrigin={{ 
        vertical: currentNotification.anchorOrigin?.vertical || 'top', 
        horizontal: currentNotification.anchorOrigin?.horizontal || 'right' 
      }}
      className={classes.snackbar}
    >
      <Alert 
        onClose={handleClose} 
        severity={getSeverity(currentNotification.type)}
        variant="filled"
        elevation={6}
      >
        {currentNotification.message}
      </Alert>
    </Snackbar>
  )
}

export default GlobalSnackbar 